/* PAPAPATTES — insère un slider promo toutes les N lignes dans la grille produits, scroll infini compris :
   on compte les cartes DÉJÀ affichées (toutes pages chargées) et on ajoute les sliders manquants à chaque ajout de produits.
   Le gabarit du slider est un <template id="pp-grid-slider-tpl"> rendu par la section (réglages : lignes, nombre, durée, aléatoire). */
(() => {
  const mq = window.matchMedia('(max-width: 989px)');
  const reslot = (rebuild) => {
    const tpl = document.getElementById('pp-grid-slider-tpl');
    const grid = document.getElementById('product-grid');
    if (!tpl || !grid || grid.tagName !== 'UL') return;
    const rows = parseInt(tpl.dataset.rows, 10) || 0;
    const cols = parseInt(mq.matches ? tpl.dataset.colsM : tpl.dataset.colsD, 10) || 1;
    if (!rows) return;
    const step = rows * cols;
    if (rebuild) grid.querySelectorAll('.pp-grid-slot').forEach((el) => el.remove());
    const cards = Array.from(grid.children).filter((li) => !li.classList.contains('pp-grid-slot'));
    for (let k = 1; k * step < cards.length; k++) {  // pas de slider après la toute dernière carte
      const anchor = cards[k * step - 1];
      const next = anchor.nextElementSibling;
      if (next && next.classList.contains('pp-grid-slot')) continue;
      anchor.after(tpl.content.firstElementChild.cloneNode(true));
    }
    if (window.ppPromoInit) window.ppPromoInit();
  };
  let timer;
  const schedule = (rebuild) => { clearTimeout(timer); timer = setTimeout(() => reslot(rebuild), 80); };
  const watch = () => {
    const box = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (!box) return;
    if (box.__ppSlots) return;
    box.__ppSlots = true;
    new MutationObserver(() => schedule(false)).observe(box, { childList: true, subtree: true });
  };
  document.addEventListener('DOMContentLoaded', () => { watch(); reslot(false); });
  mq.addEventListener('change', () => schedule(true));
  window.addEventListener('load', () => { watch(); reslot(false); });
})();
